"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mobxReact = require("mobx-react");
var _reactIntl = require("react-intl");
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _pick = _interopRequireDefault(require("lodash/pick"));
var _Field = _interopRequireDefault(require("../Field"));
var _inputUtils = require("../../utils/input-utils");
var _styles = require("./styles");
var _messages = _interopRequireDefault(require("./messages"));
var _graphql = require("@apollo/client/react/hoc/graphql");
var _mutations = require("../../api/password/mutations");
var _queries = require("../../api/password/queries");
var _mutationOptions = require("../../api/password/mutation-options");
var _queryOptions = require("../../api/password/query-options");
var _posthogUtils = require("../../utils/posthog-utils");
var _posthogEvents = require("../../posthog-events");
var _constants = require("../../constants");
var _PhoneInput = _interopRequireDefault(require("../PhoneInput"));
var _phone = _interopRequireDefault(require("phone"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class; //helpers
//messages
//data
//mutations
//queries
//options
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ResetYourPassword = (_dec = (0, _mobxReact.inject)('store'), _dec2 = (0, _graphql.graphql)(_mutations.ForgotPassword, _mutationOptions.forgotPasswordOptions), _dec3 = (0, _graphql.graphql)(_mutations.ResetPassword, _mutationOptions.resetPasswordOptions), _dec4 = (0, _graphql.graphql)(_mutations.SetPassword, _mutationOptions.setPasswordOptions), _dec5 = (0, _graphql.graphql)(_queries.ValidateResetPasswordLink, _queryOptions.validateResetPasswordLinkOptions), _dec6 = (0, _graphql.graphql)(_queries.ValidateSetPasswordLink, _queryOptions.validateSetPasswordLinkOptions), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_Component) {
  function ResetYourPassword() {
    var _this;
    _classCallCheck(this, ResetYourPassword);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ResetYourPassword, [].concat(args));
    _defineProperty(_this, "handleSubmit", function (event) {
      event.preventDefault();
      (0, _posthogUtils.posthogCapture)(_posthogEvents.posthogEvents.requestResetPasswordLink);
      var _this$props = _this.props,
        store = _this$props.store,
        forgotPasswordMutation = _this$props.forgotPasswordMutation,
        isPhone = _this$props.isPhone;
      var page = store.resetPasswordPage;
      var validateEmail = page.validateEmail,
        validatePhoneNumber = page.validatePhoneNumber;
      if (isPhone) {
        validatePhoneNumber(forgotPasswordMutation);
      } else {
        validateEmail(forgotPasswordMutation);
      }
    });
    _defineProperty(_this, "resetPassword", function (event) {
      event.preventDefault();
      var _this$props2 = _this.props,
        store = _this$props2.store,
        resetPasswordMutation = _this$props2.resetPasswordMutation;
      var page = store.resetPasswordPage,
        router = store.router,
        app = store.app;
      var views = app.views;
      var validatePassword = page.validatePassword;
      validatePassword(resetPasswordMutation, router, store, views);
    });
    _defineProperty(_this, "setPassword", function (event) {
      event.preventDefault();
      var _this$props3 = _this.props,
        store = _this$props3.store,
        setPasswordMutation = _this$props3.setPasswordMutation;
      var page = store.resetPasswordPage,
        router = store.router,
        app = store.app;
      var views = app.views;
      var validatePassword = page.validatePassword;
      validatePassword(setPasswordMutation, router, store, views);
    });
    _defineProperty(_this, "isButtonDisabled", function () {
      var _this$props4 = _this.props,
        store = _this$props4.store,
        isPhone = _this$props4.isPhone;
      var _store$resetPasswordP = store.resetPasswordPage,
        form = _store$resetPasswordP.form,
        loading = _store$resetPasswordP.loading;
      var _form$values = form.values(),
        email = _form$values.email,
        phoneNumber = _form$values.phoneNumber;
      if (loading) return true;
      if (isPhone) {
        return !phoneNumber || phoneNumber.length < 5 || !(0, _phone["default"])(phoneNumber).isValid;
      }
      return !email || !_constants.emailValidationRegex.test(email);
    });
    return _this;
  }
  _inherits(ResetYourPassword, _Component);
  return _createClass(ResetYourPassword, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$props5 = this.props,
        formatMessage = _this$props5.intl.formatMessage,
        resetPasswordPage = _this$props5.store.resetPasswordPage,
        requestResetPassword = _this$props5.requestResetPassword;
      if (!requestResetPassword) {
        (0, _posthogUtils.posthogCapture)(_posthogEvents.posthogEvents.attemptResetPassword);
      }
      var translations = (0, _mapValues["default"])((0, _pick["default"])(_messages["default"], ['canNotSentPasswordResetLink', 'canNotResetPassword', 'passwordReset', 'invalidResetCode']), function (message) {
        return formatMessage(message);
      });
      resetPasswordPage.setTranslations(translations);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var data = nextProps.data;
      var isPasswordResetLinkValid = data.isPasswordResetLinkValid,
        isPasswordSetLinkValid = data.isPasswordSetLinkValid;
      var store = this.props.store;
      var resetPasswordPage = store.resetPasswordPage;
      if (isPasswordResetLinkValid === false) {
        resetPasswordPage.resetPasswordLinkNotValid();
      }
      if (isPasswordSetLinkValid === false) {
        resetPasswordPage.resetPasswordLinkNotValid();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var store = this.props.store;
      store.resetPasswordPage.reset();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        formatMessage = _this$props6.intl.formatMessage,
        requestResetPassword = _this$props6.requestResetPassword,
        setPassword = _this$props6.setPassword,
        store = _this$props6.store,
        isMobile = _this$props6.isMobile,
        isPhone = _this$props6.isPhone;
      var _store$resetPasswordP2 = store.resetPasswordPage,
        isRequestedReset = _store$resetPasswordP2.isRequestedReset,
        setRequestReset = _store$resetPasswordP2.setRequestReset,
        form = _store$resetPasswordP2.form,
        isInvalidLink = _store$resetPasswordP2.isInvalidLink,
        emailIsNotSent = _store$resetPasswordP2.emailIsNotSent,
        loading = _store$resetPasswordP2.loading,
        passwordsMatch = _store$resetPasswordP2.passwordsMatch,
        isValidNewPassword = _store$resetPasswordP2.isValidNewPassword,
        setIsInputFocused = _store$resetPasswordP2.setIsInputFocused,
        isInputFocused = _store$resetPasswordP2.isInputFocused,
        app = store.app,
        router = store.router;
      var views = app.views;
      var _form$values2 = form.values(),
        email = _form$values2.email,
        phoneNumber = _form$values2.phoneNumber,
        resetCode = _form$values2.resetCode,
        newPassword = _form$values2.newPassword,
        newPasswordConfirm = _form$values2.newPasswordConfirm;
      var passwordFormIsValid = (isPhone ? resetCode : true) && newPassword && newPasswordConfirm;
      var inputStyles = {
        Input: (0, _styles.getHeight)()
      };
      var isValidEmail = email ? _constants.emailValidationRegex.test(email) : true;
      var isValidPhoneNumber = phoneNumber && phoneNumber > 5 ? (0, _phone["default"])(phoneNumber).isValid : true;
      var isInputValid = isPhone ? isValidPhoneNumber : isValidEmail;
      var emailSignInUrl = window.location.origin + "/sign-in/".concat(isPhone ? 'phone-number' : 'email');
      return /*#__PURE__*/_react["default"].createElement(_styles.ResetPasswordForm, {
        isMobile: isMobile
      }, /*#__PURE__*/_react["default"].createElement(_styles.Title, {
        isMobile: isMobile
      }, formatMessage(setPassword ? _messages["default"].setYourPassword : _messages["default"].resetYourPassword)), requestResetPassword && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isRequestedReset && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledDiv, null, formatMessage(isPhone ? _messages["default"].enterYourPhoneNumber : _messages["default"].enterYourEmail)), isPhone ? /*#__PURE__*/_react["default"].createElement(_PhoneInput["default"], {
        title: formatMessage(_messages["default"].phoneNumber),
        form: form,
        field: "phoneNumber",
        hideError: true
      }) : /*#__PURE__*/_react["default"].createElement(_Field["default"], _extends({
        placeholder: formatMessage(_messages["default"].email),
        field: "email",
        id: "email",
        form: form,
        styles: inputStyles,
        hideError: true,
        onFocus: function onFocus() {
          return setIsInputFocused(true);
        },
        onBlur: function onBlur() {
          return setIsInputFocused(false);
        }
      }, (0, _inputUtils.bindField)(form, 'email'))), !isInputValid && !isInputFocused && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
        name: 'warning'
      }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, formatMessage(isPhone ? _messages["default"].invalidPhoneNumber : _messages["default"].invalidEmail))), /*#__PURE__*/_react["default"].createElement(_styles.StyledButton, {
        onClick: this.handleSubmit,
        type: "submit",
        disabled: this.isButtonDisabled(),
        loading: loading
      }, formatMessage(isPhone ? _messages["default"].sendResetCode : _messages["default"].sendResetLink))), isRequestedReset && !emailIsNotSent && /*#__PURE__*/_react["default"].createElement(_styles.StyledDiv, {
        alignText: 'center',
        margin: '30px'
      }, formatMessage(_messages["default"].sentPasswordResetLink))), !requestResetPassword && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isInvalidLink && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isPhone && /*#__PURE__*/_react["default"].createElement(_Field["default"], _extends({
        placeholder: formatMessage(_messages["default"].resetCode),
        id: "resetCode",
        type: "number",
        field: "resetCode",
        form: form,
        hideError: true
      }, (0, _inputUtils.bindField)(form, 'resetCode'), {
        styles: {
          Input: _objectSpread(_objectSpread({}, (0, _styles.getHeight)()), {}, {
            margin: '0 0 5px 0'
          })
        },
        hideArrows: true
      })), /*#__PURE__*/_react["default"].createElement(_Field["default"], _extends({
        placeholder: formatMessage(_messages["default"].newPassword),
        id: "newPassword",
        type: "password",
        form: form,
        field: "newPassword",
        hideError: true
      }, (0, _inputUtils.bindField)(form, 'newPassword'), {
        withPasswordToggle: true,
        withPasswordValidation: true,
        styles: inputStyles,
        onFocus: function onFocus() {
          return setIsInputFocused(true);
        },
        onBlur: function onBlur() {
          return setIsInputFocused(false);
        },
        isInputFocused: isInputFocused
      })), !isValidNewPassword && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
        name: 'warning'
      }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, formatMessage(_messages["default"].meetAllRequirements))), /*#__PURE__*/_react["default"].createElement(_Field["default"], _extends({
        placeholder: formatMessage(_messages["default"].confirmNewPassword),
        id: "newPasswordConfirm",
        type: "password",
        field: "newPasswordConfirm",
        form: form,
        hideError: true
      }, (0, _inputUtils.bindField)(form, 'newPasswordConfirm'), {
        styles: inputStyles,
        withPasswordToggle: true
      })), !passwordsMatch && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
        name: 'warning'
      }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, formatMessage(_messages["default"].passwordsDoNotMatch))), setPassword && /*#__PURE__*/_react["default"].createElement(_styles.StyledButton, {
        onClick: this.setPassword,
        disabled: !passwordFormIsValid
      }, formatMessage(_messages["default"].setPassword)), !setPassword && /*#__PURE__*/_react["default"].createElement(_styles.StyledButton, {
        onClick: this.resetPassword,
        disabled: !passwordFormIsValid
      }, formatMessage(_messages["default"].title))), isInvalidLink && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledDiv, {
        alignText: 'center'
      }, formatMessage(setPassword ? _messages["default"].setLinkExpired : _messages["default"].resetLinkExpired)), !setPassword && /*#__PURE__*/_react["default"].createElement(_styles.StyledText, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
        onClick: function onClick() {
          router.goTo(views.requestResetPassword, {});
          setRequestReset(false);
        }
      }, formatMessage(_messages["default"].requestNewResetLink))))), /*#__PURE__*/_react["default"].createElement(_styles.StyledText, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
        href: emailSignInUrl
      }, /*#__PURE__*/_react["default"].createElement(_styles.StyledIcon, {
        name: 'arrow-left'
      }), formatMessage(_messages["default"].returnToSignIn))));
    }
  }]);
}(_react.Component)) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
var _default = exports["default"] = (0, _reactIntl.injectIntl)(ResetYourPassword);
//# sourceMappingURL=index.js.map